export const pusherMessageToRateRefreshSubject = (
  { ShippingCost = 0, InsuranceCost = 0, ConfirmationCost = 0, OtherCost = 0, DeliveryTime, RateError, RateWarnings },
  code,
) => {
  return {
    shippingCost: { value: ShippingCost, code },
    insuranceCost: { value: InsuranceCost, code },
    confirmationCost: { value: ConfirmationCost, code },
    otherCost: { value: OtherCost, code },
    totalCost: {
      value: ShippingCost + InsuranceCost + ConfirmationCost + OtherCost,
      code,
    },
    estimatedDelivery: DeliveryTime,
    errors: RateError ? [RateError] : [],
    rateWarnings: RateWarnings ? RateWarnings.map((warning) => ({ warning })) : [],
  };
};
